import { render } from "./MenuStyle.vue?vue&type=template&id=065207df"
import script from "./MenuStyle.vue?vue&type=script&lang=js"
export * from "./MenuStyle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__